import { isServer } from '@commons/utils';

let lib = null;
function getLib() {
  if (lib) return lib;
  lib = isServer() ? null : window.google.maps;
  return lib;
}

export default getLib;
